//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Popup from 'bh-mint-ui2/src/utils/popup';
import Vue from 'vue';
if (!Vue.prototype.$isServer) {
  require('bh-mint-ui2/src/style/popup.css');
}

export default {
  name: 'mt-popup',

  mixins: [Popup],

  props: {
    modal: {
      default: true
    },

    modalFade: {
      default: false
    },

    lockScroll: {
      default: true
    },

    closeOnClickModal: {
      default: true
    },

    popupTransition: {
      type: String,
      default: 'popup-slide'
    },

    position: {
      type: String,
      default: ''
    },

    pid:{
      type: String,
      default: null
    }
  },

  data() {
    return {
      currentValue: false,
      currentTransition: this.popupTransition
    };
  },

  watch: {
    currentValue(val) {
      if(!val){
        this.$emit("maskCallback");
        if(this.pid){
          document.getElementById(this.pid).style.overflow = null;
          document.getElementById(this.pid).style.height = null;
        }
      };
      this.$emit('input', val);
    },

    value(val) {
      this.currentValue = val;
    }
  },
  beforeMount() {
    if (this.popupTransition !== 'popup-fade') {
      this.currentTransition = `popup-slide-${ this.position }`;
    }
  },

  mounted() {
    if (this.value) {
      this.rendered = true;
      this.currentValue = true;
      this.open();
    }
  }
};



// WEBPACK FOOTER //
// ./packages/popup/src/popup.vue